import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import HomePage from './pages/HomePage';
import GalleryPage from './pages/GalleryPage';
import NotFound from './pages/NotFound';
import Navbar from './components/Navbar';
import initAOS from './utils/aos-init';
import './styles/globals.css';
import './styles/theme.css';

const App = () => {
  useEffect(() => {
    initAOS();
  }, []);

  return (
    <ThemeProvider>
      <Router>
        {/* Grid background */}
        <div className="grid-bg"></div>
        
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          {/* Catch-all route for 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;